import { useCallback, useLayoutEffect, useMemo } from 'react'
import { ANIMATED_BG_LINK } from 'root-constants'

export const useAnimatedBackground = () => {
  const shouldAnimationStop = useMemo(() => {
    const pathName = window.location.pathname
    return (
      pathName.includes('/purchase') ||
      pathName.includes('/result') ||
      pathName.includes('/download')
    )
  }, [])

  const handleMouseDown = useCallback((event: MouseEvent) => {
    const ANIMATION_DURATION = 750
    const canvasElem = document.querySelector('canvas')

    canvasElem &&
      setTimeout(() => {
        canvasElem.dispatchEvent(
          new MouseEvent('mouseup', {
            view: window,
            bubbles: true,
            cancelable: true,
            screenX: event.clientX,
            screenY: event.clientY,
          }),
        )
      }, ANIMATION_DURATION)
  }, [])

  useLayoutEffect(() => {
    if (shouldAnimationStop) return
    const canvasElem = document.querySelector('canvas')
    const script = document.createElement('script')
    script.id = 'animation-script'
    script.type = 'module'
    script.src = ANIMATED_BG_LINK
    script.async = true
    script.onload = () => {
      canvasElem?.addEventListener('mousedown', handleMouseDown)
    }
    document.body.appendChild(script)

    // eslint-disable-next-line consistent-return
    return () => canvasElem?.removeEventListener('mousedown', handleMouseDown)
  }, [handleMouseDown, shouldAnimationStop])
}
